import React from "react";
import closeIcon from "../../assets/cross.svg";

const DeactivateSchoolModal = ({ onClose, onConfirm, isLoading = false }) => {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex justify-center items-center">
      <div className="w-[500px] bg-white rounded-[20px] overflow-hidden font-['Manrope']">
        {/* Header */}
        <div className="p-6 bg-gradient-to-br from-white to-blue-100 border-b border-blue-100 flex justify-between items-center">
          <h2 className="text-[18px] font-bold text-gray-900">
            Deactivate School Access?
          </h2>
          <button onClick={onClose} className="p-1">
            <img src={closeIcon} alt="Close" className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 pb-6 pt-6 flex flex-col gap-8">
          <div className="text-[16px] leading-normal">
            <span className="text-gray-500 font-medium">
              Are you sure you want to deactivate access for this school?{" "}
            </span>
            <span className="text-gray-800 font-bold">
              This will immediately suspend access for the administrator and all
              associated students.
            </span>
            <br />
            <br />
            <span className="text-gray-800 font-bold">
              This action is permanent and the account cannot be recovered or
              reactivated later.
            </span>
          </div>

          {/* Footer Buttons */}
          <div className="flex justify-end gap-2">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="h-11 px-4 py-1.5 text-[16px] font-medium text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              disabled={isLoading}
              className="h-11 px-4 py-1.5 text-[16px] font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors disabled:opacity-70 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isLoading && (
                <svg
                  className="animate-spin h-4 w-4 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
              )}
              {isLoading ? "Deactivating..." : "Deactivate"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeactivateSchoolModal;
